<template>
  <div
    class="app-main-content"
    element-loading-text="."
    element-loading-spinner="none"
    element-loading-background="rgba(170,170,170,0)"
  >
    <account-month-grid />
  </div>
</template>

<script>

import AccountMonthGrid from '@/views/cargo/v0/Information/AccountingMonth/components/AccountMonthGrid'
export default {
  name: 'AccountingMonth',
  components: { AccountMonthGrid }
}
</script>
